module.exports = __webpack_public_path__ + "static/media/removePoint.97f8f469.svg";